
import ScenePrefabDialog from './ScenePrefabDialog.vue';
import _get from 'lodash/get';
import _set from 'lodash/set';

export default {
  components: {
    ScenePrefabDialog: ScenePrefabDialog
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectPrefab: function selectPrefab() {
      var url = _get(this.model, this.config.prop + '.url');
      // eslint-disable-next-line no-undefined
      if (!url) return undefined;
      url = url.substring(url.lastIndexOf('/') + 1);
      return url;
    }
  },
  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    openScenePrefabDialog: function openScenePrefabDialog() {
      this.$refs.ScenePrefabDialog.openDialog();
    },
    selectPrefabHandler: function selectPrefabHandler(prefab) {
      var prop = this.realProp();
      console.log(prop, this.model, this.config);
      _set(this.model.script, prop, prefab);
      _set(this.model, this.config.prop, prefab);
    }
  }
};